module.exports = __webpack_public_path__ + "static/media/res4.ecee876a.PNG";